import { User, SessionData } from '@auth0/nextjs-auth0/types';

export const FFH_DEMO_CLAIM = 'https://fantasyfootballhub.co.uk/demo';

export interface Auth0UserInfo extends User {
  sub: string;
  nickname: string;
  name: string;
  picture: string;
  updated_at: string;
  [FFH_DEMO_CLAIM]?: boolean;
  'https://fantasyfootballhub.co.uk/roles': string[];
  'https://fantasyfootballhub.co.uk/externalUserId': number;
  'https://fantasyfootballhub.co.uk/profileId'?: string;
  'https://fantasyfootballhub.co.uk/subscription': {
    source: {
      id: string;
      provider: string;
    };
    status: string;
    tier: string;
    term: string;
    trial: {
      endAt: string;
      startAt: string;
    };
  };
  loginCount: number;
  [key: string]: unknown;
}

export interface Auth0Session extends SessionData {
  user: Auth0UserInfo;
  accessToken?: string;
}

/**
 * Reads the Auth0 demo claim from the user object. Returns false unless the
 * claim is exactly true, so a missing user, a missing claim or a truthy
 * non-boolean value all count as a standard session.
 */
export const isDemoUser = (user: Auth0UserInfo | null | undefined): boolean =>
  user?.[FFH_DEMO_CLAIM] === true;
